<lib-button-neutral (buttonClicked)="buttonClicked.emit()">
  <img [src]="iconSrc" alt="icon" i18n-alt class="icon" />
  {{ label }}
</lib-button-neutral>
